import { render, staticRenderFns } from "./LabelRequired.vue?vue&type=template&id=20e17bf8&scoped=true&"
import script from "./LabelRequired.vue?vue&type=script&lang=js&"
export * from "./LabelRequired.vue?vue&type=script&lang=js&"
import style0 from "./LabelRequired.vue?vue&type=style&index=0&id=20e17bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e17bf8",
  null
  
)

export default component.exports